import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'mlp-ng-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationSharedComponent {}
